import { ValidationDisplayInfo } from '../DisplayHelper';
import { RuleSeverity } from '../ValidationState';
var DefaultValidator = /** @class */ (function () {
    function DefaultValidator() {
        this.isValid = true;
        this.hasBlurred = false;
        this.emptyDisplayInfo = new ValidationDisplayInfo();
        this.emptyDisplayInfo.severity = RuleSeverity.None;
    }
    DefaultValidator.prototype.getDisplayState = function (validationMode) {
        return this.emptyDisplayInfo;
    };
    return DefaultValidator;
}());
export var EmptyValidator = new DefaultValidator();
